import React, { useState } from 'react'
import { StartPaymentFrontend } from '../../../tikexModule/Types/dto/startPayment'
import useLocalStorageTX2 from '../../../tikexModule/hooks/useLocalStorageTX2'

export default function QuantityEditor({
	adSubPageId,
	invoiceItemId,
}: {
	adSubPageId: string
	invoiceItemId: string
}) {
	const [value, setValue] = useState<string | undefined>(undefined)
	const [startPaymentFrontend, setStartPaymentFrontend] =
		useLocalStorageTX2<StartPaymentFrontend>('startPaymentFrontend.v4', {
			adSubPagesData: {},
			formFieldData: {},
			partnerData: { country: 'Magyarország' },
		})
	return (
		<input
			className="input-text"
			value={
				value ??
				startPaymentFrontend?.adSubPagesData[adSubPageId]?.productData?.[
					invoiceItemId
				] ??
				'0'
			}
			onChange={(event) => {
				if (invoiceItemId && startPaymentFrontend) {
					setValue(event.target.value)
					let i = parseInt(event.target.value)
					if (isNaN(i)) {
						return
					}
					const _startPaymentFrontend = {
						...startPaymentFrontend,
						adSubPagesData: {
							...startPaymentFrontend?.adSubPagesData,
							[adSubPageId]: {
								...startPaymentFrontend?.adSubPagesData[adSubPageId],
								productData: { [invoiceItemId]: i },
							},
						},
					}
					setStartPaymentFrontend(_startPaymentFrontend)
					dispatchEvent(
						new CustomEvent('startPaymentReqsChanged', {
							detail: _startPaymentFrontend,
						})
					)
				}
			}}
		/>
	)
}
